export default __webpack_public_path__ + "static/media/Lip_2_F.e47b8322.svg";